import { render, staticRenderFns } from "./MatchLine.vue?vue&type=template&id=fdf6dd20&scoped=true&"
import script from "./MatchLine.vue?vue&type=script&lang=ts&"
export * from "./MatchLine.vue?vue&type=script&lang=ts&"
import style0 from "./MatchLine.vue?vue&type=style&index=0&id=fdf6dd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6dd20",
  null
  
)

export default component.exports